import React from 'react';

export type DetailListItem = {
  label: string;
  value: React.ReactNode;
};

type DetailListProps = {
  items: DetailListItem[];
  className?: string;
};

export function DetailList({ className = 'incident-details', items }: DetailListProps) {
  return (
    <dl className={className}>
      {items.map((item) => (
        <div key={item.label}>
          <dt>{item.label}</dt>
          <dd>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
